export const formateCityName = (name: string): string => {
  const formateText = name.toLowerCase().replace(/\s+/g, '-');
  return formateText;
};

export const formatCityNameForDisplay = (urlName: string): string => {
  return urlName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};